import React from 'react';

const microbeData = [
  { name: 'Escherichia coli', Resilience: 7, Mobility: 5, Metabolism: 4, trait: 'Press' },
  { name: 'Bacillus subtilis', Resilience: 6, Mobility: 4, Metabolism: 3, trait: 'Heat' },
  { name: 'Pseudomonas aeruginosa', Resilience: 5, Mobility: 6, Metabolism: 5, trait: 'Press' },
  { name: 'Clostridium difficile', Resilience: 8, Mobility: 7, Metabolism: 6, trait: 'Heat' },
  { name: 'Staphylococcus aureus', Resilience: 4, Mobility: 3, Metabolism: 2, trait: 'Press' },
  { name: 'Helicobacter pylori', Resilience: 7, Mobility: 6, Metabolism: 4, trait: 'Press' },
  { name: 'Lactobacillus acidophilus', Resilience: 6, Mobility: 5, Metabolism: 5, trait: 'Heat' },
  { name: 'Salmonella enterica', Resilience: 5, Mobility: 4, Metabolism: 3, trait: 'Press' },
  { name: 'Mycobacterium tuberculosis', Resilience: 8, Mobility: 7, Metabolism: 6, trait: 'Heat' },
  { name: 'Vibrio cholerae', Resilience: 6, Mobility: 6, Metabolism: 5, trait: 'Hydro' },
];

const traitColors = {
  'Press': '#60A5FA',
  'Hydro': '#38BDF8',
  'Aero': '#A3E635',
  'Heat': '#F87171',
};

const traitIcons = {
  'Press': '🧬',
  'Hydro': '💧',
  'Aero': '🌬️',
  'Heat': '🔥',
};

const attrIcons = {
  Resilience: '🛡️',
  Mobility: '🏃',
  Metabolism: '⚡',
};

function MicrobeCard({ name, Resilience, Mobility, Metabolism, trait }) {
  return (
    <div className="microbe-card flex flex-col items-center rounded-2xl bg-white shadow-md p-4 w-full sm:w-[calc(100%-16px)] md:w-56 min-h-[320px] border border-gray-100 relative">
      {/* Image placeholder */}
      <div className="w-16 h-16 rounded-full flex items-center justify-center mb-2 mt-2" style={{ background: traitColors[trait] + '22' }}>
        <span style={{ fontSize: 36 }}>{traitIcons[trait]}</span>
      </div>
      <div className="font-semibold text-base text-gray-800 mb-2 text-center">{name}</div>
      <div className="text-xs text-gray-400 mb-1">Attributes</div>
      <div className="flex flex-col gap-2 w-full mb-3">
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.Resilience}</span>Resilience</span>
          <span className="font-bold text-gray-800">{Resilience}</span>
        </div>
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.Mobility}</span>Mobility</span>
          <span className="font-bold text-gray-800">{Mobility}</span>
        </div>
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.Metabolism}</span>Metabolism</span>
          <span className="font-bold text-gray-800">{Metabolism}</span>
        </div>
      </div>
      <div className="text-xs text-gray-400 mb-1">Trait</div>
      <div className="flex items-center gap-2 mt-1">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded bg-white border" style={{ background: traitColors[trait], color: '#fff' }}>{traitIcons[trait]}</span>
        <span className="text-sm font-medium text-gray-700">{trait}</span>
      </div>
    </div>
  );
}

export default function BioticMadnessMicrobeCardsGrid() {
  return (
    <div className="w-full flex flex-wrap gap-4 md:gap-6 justify-center">
      {microbeData.map((microbe, idx) => (
        <MicrobeCard key={microbe.name + idx} {...microbe} />
      ))}
    </div>
  );
} 